export default "__VITE_ASSET__DJlwkbu4__"